/* esm.sh - longest-streak@3.1.0 */
function f(l,t){let i=String(l),e=i.indexOf(t),n=e,o=0,r=0;if(typeof t!="string")throw new TypeError("Expected substring");for(;e!==-1;)e===n?++o>r&&(r=o):o=1,n=e+t.length,e=i.indexOf(t,n);return r}export{f as longestStreak};
//# sourceMappingURL=longest-streak.mjs.map